import { message } from 'antd';
import { apiGet, apiPost, parseJsonResponse } from './apiClient';

export const getKontakte = async (filter_active = false) => {
  try {
    const filters = filter_active ? '&filters[archived][$eq]=0' : '';
    const url = `/helper/acl/kontakte?fields[0]=KontakttypV&fields[1]=Kontaktname${filters}`;
    const response = await apiGet(url);
    const dataContainer = await parseJsonResponse(response);
    const result = {};
    dataContainer.forEach((entry) => {
      if (entry.Kontaktname !== null) result[entry.id] = entry;
    });
    return result;
  } catch (error) {
    console.log(error);
    message.error('Error while fetching profiles!');
  }
};

export const handleCreateKontakt = async (navigate, auftragID) => {
  try {
    const response = await apiPost('/helper/acl/kontakte', {});
    if (response.ok) {
      const body = await parseJsonResponse(response);
      navigate(auftragID ? `/kontakte/${body.id}/${auftragID}` : `/kontakte/${body.id}/0`);
    } else {
      console.error('Fehler beim Erstellen des Eintrags.');
    }
  } catch (error) {
    console.error('Fehler beim Erstellen des Eintrags:', error);
  }
};
